import axios from "axios";
import store from "@/store";

// let user = JSON.parse(localStorage.getItem("sprkr/user"));

const baseURL = `${process.env.VUE_APP_API_HTTP || ""}/api`;

const instance = axios.create({ baseURL });

instance.interceptors.request.use(config => {
  let { account } = store.state;
  if (account.loggedIn && account.user.key) {
    config.headers["Authorization"] = `Token ${account.user.key}`;
  }
  return config;
});

export default instance;
